import React from 'react'
import { FormattedMessage } from 'react-intl'

export const BATTLE_ROOMS_FILTER = {
    notInBattle: (
        <FormattedMessage
            id='battle_rooms.filter_notInBattle'
            defaultMessage='Не в бою'
        />
    ),
    places: (
        <FormattedMessage
            id='battle_rooms.filter_places'
            defaultMessage='Есть места'
        />
    ),
}

export const WAITING_FOR_PLAYERS_TOOLTIP = {
    id: 'WAITING_FOR_PLAYERS_TOOLTIP_ID',
    title: (
        <FormattedMessage
            id='battle_rooms.filter.waiting_for_players_tooltip_title'
            defaultMessage='Не в бою'
        />
    ),
    message: (
        <FormattedMessage
            id='battle_rooms.filter.waiting_for_players_tooltip'
            defaultMessage='Нажмите, чтобы показать только те отряды, которые не находятся в бою.'
        />
    ),
}

export const HAS_FREE_SLOTS_TOOLTIP = {
    id: 'HAS_FREE_SLOTS_TOOLTIP_ID',
    title: (
        <FormattedMessage
            id='battle_rooms.filter.has_free_slots_tooltip_title'
            defaultMessage='Есть места'
        />
    ),
    message: (
        <FormattedMessage
            id='battle_rooms.filter.has_free_slots_tooltip'
            defaultMessage='Нажмите, чтобы показать только те отряды, в которых есть свободные места.'
        />
    ),
}



// WEBPACK FOOTER //
// ./containers/BattleRooms/components/UnitCheckboxFilter/constants.jsx